import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sources'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_sources_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'settings_sources_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_sources_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
